import axios from "axios";
import { productUrl } from "../../Config/Url";

export const productService = {
  getProductsByReceiptGuid,
};

async function getProductsByReceiptGuid(receiptGuid) {
  return axios
    .get(`${productUrl}/${receiptGuid}/receipt`)
    .then((res) => res)
    .catch((err) => err.response);
}
